import {Box, Button, Divider, Stack} from '@mui/material';
import {AppointmentBookingEnum, FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {AlertInfo} from 'presentation/components';
import {EmptySearchState} from 'presentation/components/EmptySearchState';
import {PhonesDrawer} from 'presentation/components/PhonesDrawer';
import {PhonesMenu} from 'presentation/components/PhonesMenu';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useHealthUnitsNotFoundState} from './hooks/useHealthUnitsNotFoundState';
import {Loading} from 'presentation/components/Loading/Loading';

const {noResults, call, callToChat} = translations['pt-br'].commons;

export function HealthUnitsNotFoundState() {
	const {
		emptyDescription,
		primaryButtonConfig,
		handleCallChatRoom,
		handleOpenPhoneMenu,
		isMobile,
		openPhoneDrawerState,
		handleTogglePhoneDrawer,
		choosePhoneNumber,
		phoneNumbersAlert,
		phoneNumbers,
		isPhoneNumberMenuOpen,
		anchorEl,
		handleClosePhoneMenu,
		callChatRoomIsLoading,
	} = useHealthUnitsNotFoundState();

	return (
		<Fragment>
			<EmptySearchState
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_UNIDADES_AGENDAMENTO_DISPONIVEL}
				title={noResults}
				description={emptyDescription}
				imageV2>
				<Stack gap={2}>
					<Button
						variant="contained"
						size="large"
						data-tag-id={primaryButtonConfig.dataTagId}
						onClick={primaryButtonConfig.action}>
						{primaryButtonConfig.label}
					</Button>

					<Divider />

					<Button
						variant={'outlined'}
						size="large"
						data-tag-id={AppointmentBookingEnum.CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO}
						onClick={handleCallChatRoom}
						disabled={callChatRoomIsLoading}
						endIcon={
							callChatRoomIsLoading ? <Loading size={16} color="inherit" /> : null
						}>
						{callToChat}
					</Button>

					<Button
						variant={'outlined'}
						size="large"
						data-tag-id={AppointmentBookingEnum.CLICK_LIGAR_AGENDAMENTO}
						onClick={handleOpenPhoneMenu}>
						{call}
					</Button>
				</Stack>
			</EmptySearchState>

			{isMobile ? (
				<PhonesDrawer.Root
					open={openPhoneDrawerState}
					toggleDrawer={handleTogglePhoneDrawer}
					title={choosePhoneNumber}>
					<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>
					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesDrawer.Root>
			) : (
				<PhonesMenu.Root
					open={isPhoneNumberMenuOpen}
					onClose={handleClosePhoneMenu}
					anchorEl={anchorEl}>
					<Box pb={2}>
						<AlertInfo.Root>{phoneNumbersAlert}</AlertInfo.Root>
					</Box>
					<PhonesDrawer.WithTitle phoneNumbers={phoneNumbers} />
				</PhonesMenu.Root>
			)}
		</Fragment>
	);
}
